<template>
<div class="col-12">

      <Dialog header="Incidencia" v-model:visible="showReportIncidenceModal" :style="{width: '50vw'}">
        <div  class="grid" >
            <div class="col-12">
                <div class="status_box status-2 w-full">{{incidence}}</div>
            </div>
            <div class="col-12">
                <p class="text-center">Tipo: {{incidence_type}}</p>
            </div>
            <div class="col-12 text-center">
                <Button
                  label="Aprobar"
                  icon="pi pi-check"
                  class="p-button-info mr-2"
                  @click="updateIncidence('aprobar')"
                /> 
                <Button
                  label="Desaprobar"
                  icon="pi pi-times"
                  class="p-button-danger mr-2"
                  @click="updateIncidence('rechazar')"
                /> 
            </div>
        </div>
    </Dialog>
  
    <div class="oti_square">

    <div class="flex justify-content-between">
        <div class="os_number">
            <b>PPP - {{ otiName(order.id) }} | Cód: {{order.codigo}}</b>            
        </div>
        <div class="" v-if="order.incidencia_pendiente && order.incidencia_pendiente.length">
            <div :class="'status_box status-8'" @click="showIncidence(order.incidencia_pendiente[0])">VER INCIDENCIA</div>
        </div>
        <div class="">
            <div :class="'status_box status-'+priorityClass" @click="updatePriority()">PRIORIDAD {{priorityName }}</div>
        </div>
        <div class=""  v-if="! order.machine_id || order.machine_id.id != 1">
            <div :class="'status_box status-' + order.status">{{ statusName }}</div>
        </div>
        <div class=""  v-else>
            <div :class="'status_box status-' + order.status">{{ statusName }}</div>
        </div>
    </div>

    <div class="">
      <div class="row flex justify-content-between">
        <div class="os_detail">
           
        </div>
        <div style="" class="os_clock">
           {{ secsParsed(order.time)}} 
        </div>
        
      </div>

        
        <div class="row">
          <!--
          <div class="os_number">
            <span class="mb-2" v-if="order.details">
                <b>
                <i class="pi pi-fw pi-search"> </i> 
                {{ order.details }} 
                <br />
              </b>
            </span>
             <span class="mt-2 col-3" v-if="order.alto">Alto: {{ order.alto }}  </span>
             <span class="mt-2 col-3" v-if="order.ancho">Ancho: {{ order.ancho }}  </span>
             <span class="mt-2 col-3" v-if="order.espesor">Espesor: {{ order.espesor }}  </span>
             <span class="mt-2 col-3" v-if="order.plisas">Plisas: {{ order.plisas }}</span>
          </div>        
          <br />
          <div class="mt-2 status_box status-0" v-if="order.sector">
             Sector: {{ order.sector.name }}
          </div>
        -->
          
        </div>

        <div v-if="order?.productos && order?.productos.length" class="status_products col-12">
            <h4 class="text-blue">PRODUCTOS</h4>
        
            <div class="">
                <div class="formgrid grid">
                    <div class="field col-2">
                      <label for="alto">NOMBRE</label>              
                    </div>
                    <div class="field col-1">
                      <label for="alto">CANT</label>              
                    </div>
                    <div class="field col-1">
                      <label for="alto">MEDIDA</label>              
                    </div>
                    <div class="field col-1">
                      <label for="alto">MATERIAL</label>
                    </div>
                    <div class="field col-2">
                      <label for="alto">CLASE-EFIC.</label>
                    </div>
                    <div class="field col-3">
                      <label for="alto">SECTOR</label>
                    </div>
                    <div class="field col-2">
                    </div>
                </div>
                <div class="formgrid grid pt-3" v-for="prod of order.productos">
                    <div class="field col-2">
                      <span type="text" class="inputfield w-full">
                        <b>{{ prod.producto.name }}</b>
                      </span>
                    </div>
                    <div class="field col-1">
                      <span type="text" class="inputfield w-full">
                        <b>{{ prod.cantidad }}</b>
                      </span>
                    </div>
                    <div class="field col-1">
                      <span type="text" class="inputfield w-full">
                        <b>{{ prod.medida }}</b>
                      </span>
                    </div>
                    <div class="field col-1">
                      <span type="text" class="inputfield w-full">
                        <b>{{ prod?.material?.name }}</b>
                      </span>
                    </div>
                    <div class="field col-2">
                      <span type="text" class="inputfield w-full">
                        <b>{{ prod.clase }}</b>
                      </span>
                    </div>
                    <div class="field col-3">
                      <span type="text" class="inputfield w-full">
                        {{ prod.sector }}
                        <small v-if="prod.operator_name"> <i class="pi pi-fw pi-user mr-1"> </i> {{prod.operator_name}}</small>
                      </span>
                    </div>
                    <div class="field col-2" >
                      <span type="text" class="inputfield w-full">
                        <OtiActionsSmallAdmin :order="prod" :userGroup="this.userGroup" @statusChange="statusChanged"
                        />
                      </span>
                    </div>
                </div>  
            </div>
        </div>


    </div>
    

    
          <!--
    <div class="flex justify-content-between" v-if="! order.machine_id || order.machine_id.id != 1">
        <div class="os_detail">
            <i class="pi pi-fw pi-user mr-1"> </i> 
            {{ giveMeName(order.current_operator, 'usuario') }} 
        </div>
        
        <div>              
            <OtiActionsSmallAdmin :order="order" :userGroup="this.userGroup" />            
        </div>
    </div>
          -->

    <!--
    <div class="flex justify-content-between" v-else>
        <div class="os_detail">
            <i class="pi pi-fw pi-cog mr-3"> </i> 
            TORNO FANUC
        </div>
        <div>
               <div style="" class="">
           <small  class="os_detail"> TIEMPO TOTAL: {{ secsParsed(order.total_time)}} </small> 
        </div>
            
        </div>
    </div>
  -->

    </div>
</div>
</template>

<script>
import OtiActionsSmallAdmin from "./../OtiActionsSmallAdmin";
import CrudService from "./../../services/crud.service.js";


export default {
  components: {
    OtiActionsSmallAdmin,
  },
  props: ["order", "size", "userGroup"],
  data() {
    return {
        dinamycStatus: this.order.status,
        elapsed: 0,
        clients: [],
        users: [],
        machines: [],
        incidence_id: null,
        incidence: '',
        incidence_type: '',
        showReportIncidenceModal: false,
        priority_name: [{'low': 'BAJA', 'medium': 'MEDIA', 'high': 'ALTA'}],
    };
  },
  created() {
    setInterval(
      function () {
        if (this.order.status == 1 || this.order.status == 7) {
          this.order.time++;
        } else {
        }
      }.bind(this),
      1000
    );
  },
  mounted() {
    this.dinamycStatus = this.order.status;
    //CrudService.getCRUD("cliente").then((data) => (this.clients = data));
    CrudService.getCRUD("usuario").then((data) => (this.users = data));
    //CrudService.getCRUD("maquinaria").then((data) => (this.machines = data));
  },
  methods: {
    getStatusName(status) {
      let statuses = ['Sin Inic.', 'En Proc.', 'Pausada', 'Calidad', 'Finalizada'];
      if (statuses[status] && statuses[status]!=null) {
        return statuses[status];
      }
      return '';
    },
    statusChanged() {
          console.log('statusChanged')
          //location.reload();
          setInterval(
            function () {
              location.reload();
            }.bind(this),
            5000
          );
      },
    showIncidence(incidence) {
      this.incidence_id = incidence.id;
      this.incidence = incidence.descripcion;
      this.incidence_type = incidence.tipo?.name;
      this.showReportIncidenceModal = true;
    },
    updateIncidence(mode) {
      let data = {id: this.incidence_id};
      CrudService.updateCRUD('incidencia', mode, data).then((data) => {
            this.validationErrors = [];
            if (data.status == 400) { 
              this.displayErrors(data.data);
            } else {
              this.$toast.add({
                severity: "success",
                summary: "Éxito!",
                detail: "Actualizado correctamente.",
                life: 3000,
              });
              this.incidence_id = null;
              this.incidence = '';
              this.incidence_type = '';
              this.showReportIncidenceModal = false;
              location.reload()
            }
          });
    },
    updatePriority() {
      if (this.userGroup != 1 && this.userGroup != 5) {
        return false;
      }
      let priority = this.order.priority == 'high' ? 'normal' : (this.order.priority == 'medium' ? 'high' : 'medium');
      let data = {id: this.order.id, priority: priority};
      CrudService.updateCRUD('orden', 'prioridad', data).then((data) => {
            this.validationErrors = [];
            if (data.status == 400) { 
              this.displayErrors(data.data);
            } else {
              this.$toast.add({
                severity: "success",
                summary: "Éxito!",
                detail: "Actualizado correctamente.",
                life: 3000,
              });
              //location.reload()
              this.order.priority = data.priority;
            }
          });
    },
      otiName(id=null) {
        // str pad left 0000
        return ("0000" + id).slice(-4);        
      },
      giveMeName(id=null, table) {
        if(table == 'cliente'){
          let exist = this.clients.find((client) => client.id === id);
          if (!exist) {
            return " - ";
          } else {
            return exist.name;
          
          }
        }

        if (table == 'maquinaria'){
          let exist = this.machines.find((machine) => machine.id === id);
          if (!exist) {
            return " - ";
          } else {
            return exist.name;
          
          }
        }

        if(table == 'usuario') {
          let exist = this.users.find((user) => user.id == id);

          if (!exist) {
            return " - ";
          } else {
            let name = exist.name;
            if (exist.last_name) {
              name += ' ' + exist.last_name;
            }
            return name;
          }
        }
    },
    actionClicked(e) {
      this.dinamycStatus = e;

      console.log("actionClicked", e, this.elapsed);
    },
    secsParsed: function (sec) {
      var hours = Math.floor(sec / 3600);
      hours >= 1 ? (sec = sec - hours * 3600) : (hours = "00");
      var min = Math.floor(sec / 60);
      min >= 1 ? (sec = sec - min * 60) : (min = "00");
      sec < 1 ? (sec = "00") : void 0;

      let ph = "00";
      if (hours >= 1) {
        ph = String(hours).padStart(2, "0");
      }
      let sec2 = "00";
      if (sec >= 1) {
        sec2 = String(sec).padStart(2, "0");
      }

      min.toString().length == 1 ? (min = "0" + min) : void 0;

      return ph + ":" + min + ":" + sec2;
    },
  },
  computed: {
    priorityName() {
      switch (this.order.priority) {
        case 'high':
          return "ALTA";
        case 'medium':
          return "MEDIA";
        default:
          return "NORMAL";
      }
    },
    priorityClass(){
      if (this.order.priority == 'high' || this.order.priority == 'medium') {
        return this.order.priority;
      }

      return "normal";
    },
    statusClass() {
      switch (this.order.status) {
        case 0:
          return "pi pi-user";
        case 1:
          return "pi pi-play";
        case 2:
          return "pi pi-pause";
        case 3:
          return "pi pi-check";
        case 4:
          return "pi pi-star";
        default:
          return "pi pi-exclamation-circle";
      }
    },
    statusName() {
      switch (this.order.status) {
        case '0':
          return " Sin Iniciar";
        case '1':
          return " En proceso";
        case '2':
          return " En pausa";
        case '3':
          return " En calidad";
        case '4':
          return " Aprobada";
        case '5':
          return " En pausa / DESAPROBADA";
        case '6':
          return " En torno / EN COLA";
          case '7':
          return " En torno / EN PROCESO";
          case '8':
          return " En incidencia";
        default:
          return this.order.status; //" - ";
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.os_number {
    text-align: left;

letter-spacing: 0px;
color: #9A9A9A;
}

.os_detail {
text-align: left;
font-size: 16px;
line-height: 40px;
letter-spacing: 0px;
color: #0C0C0C;
font-weight: bold;
}

.os_clock {
text-align: left;
font-size: 32px;
line-height: 40px;
letter-spacing: 0px;
color: #0C0C0C;
}
.oti_square {
background: #FFFFFF 0% 0% no-repeat padding-box;
border: 1px solid #D8D8D8;
padding: 24px;
}


.status_box {
    display: inline-block;          
    text-align: center;
    padding: 3px;
    text-transform: uppercase;
  }
  .status-normal {
      border: 1px solid #6B6B6B;
      background-color: #E4E5E5;
      color: #6F6C6C;
  }
  .status-high {
      border: 1px solid #E53C3C;
      background-color: #FC7A7A;
      color: #fff;
  }
  .status-medium {
      border: 1px solid #ECD222;
      background-color: #F0E6A4;
      color: #585858;
  }
  .status-8 {
      border: 1px solid #F06A08;
      background-color: #F6964F;
      color: #302F2F;
  }      
  .status-7 {
      border: 1px solid #44b73a71;
      background-color: #44b73a71;
  }      
  .status-6 {
      border: 1px solid #2ce4d49a;
      background-color: #2ce4d535;
      color: #000;
  }
  .status-5 {
      border: 1px solid #ff99005b;
      background-color: #ff99005b;
      color: #000;
  }
  .status-4 {
      border: 1px solid #2ce4d49a;
      background-color: #2ce4d535;
  }
  .status-3 {
      border: 1px solid #44b73a71;
      background-color: #44b73a71;
  }
  .status-2 {
      border: 1px solid #ff99005b;
      background-color: #ff99005b;
  }
  .status-1 {
      border: 1px solid #44b73ae3;
      background-color: #44b73a71;
    
  }
  .status-0 {
      border: 1px solid #d8d8d89a;
      background-color: #d8d8d89a;
  }

.oti_clock {
  padding: 5px 25px 5px 25px;
  text-transform: uppercase;
  line-height: 50px;
  font-size: 26px;
  & > div i {
    font-size: 22px;
    line-height: 30px;
  }
  &.st_bg_color_3 {
    border: 1px solid #44b73a71;
    background-color: #44b73a71;
    & > div i {
      color: #44b73a;
    }
  }
  &.st_bg_color_2 {
    border: 1px solid #ff99005b;
    background-color: #ff99005b;
    & > div i {
      color: #ff9800;
    }
  }
  &.st_bg_color_1 {
    border: 1px solid #1c96c256;
    background-color: #1c96c256;
    & > div i {
      color: #0b3b5a;
    }
  }
  &.st_bg_color_0 {
    background-color: #d8d8d89a;
    background-color: #d8d8d89a;
    & > div i {
      color: #807f7f;
    }
  }

  .reportButtonOk {
    color: #fff;
    background-color: #4CC35A;
  }
}
.text-blue {
  color: #DE6C06;
}
.status_products {
    border: 1px solid #ECCE94;
    background-color: #F1F1D3;
    color: #6F6C6C;
    margin-bottom: 1rem;
}
.st_bg_color_3 i {
  color: #1EC549;
}
</style> 
